module.exports = __webpack_public_path__ + "img/bannerlink.d1bad99a.png";